import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Summary , Preference } from '../summary.model';
import { SummaryActions, SummaryActionTypes } from '../actions/summary.actions';

export interface State extends EntityState<Summary> {
  // additional entities state properties
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Summary> = createEntityAdapter<Summary>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  Loaded: false,
  Loading: false
});

export interface PreferencesState {
  Loaded: boolean;
  Loading: boolean;
  entities: Preference;
}

export const initialStateforPreferences: PreferencesState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface SummaryDetailState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforSummaryDetailState: SummaryDetailState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: SummaryActions
): State{
  switch (action.type) {
    case SummaryActionTypes.GetSummary: {
      return {...state, Loaded: false, Loading: true};
    }

    case SummaryActionTypes.AddSummary: {
      return adapter.addOne(action.payload.summary, state);
    }

    case SummaryActionTypes.UpsertSummary: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case SummaryActionTypes.AddSummarys: {
      return adapter.addMany(action.payload.summarys, state);
    }

    case SummaryActionTypes.UpsertSummarys: {
      return adapter.upsertMany(action.payload.summarys, state);
    }

    case SummaryActionTypes.UpdateSummary: {
      return adapter.updateOne(action.payload.summary, state);
    }

    case SummaryActionTypes.UpdateSummarys: {
      return adapter.updateMany(action.payload.summarys, state);
    }

    case SummaryActionTypes.DeleteSummary: {
      return adapter.removeOne(action.payload.id, state);
    }

    case SummaryActionTypes.DeleteSummarys: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case SummaryActionTypes.LoadSummarys: {
      return adapter.setAll(action.payload.summarys, state);
    }

    case SummaryActionTypes.ClearSummarys: {
      return adapter.removeAll(state);
    }

    case SummaryActionTypes.GetSummaryFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case SummaryActionTypes.NoSummaryInfo: {
      return {...state, Loaded: true, Loading: false};
    }
    
    default: {
      return state;
    }
  }
}

export function preferencesReducer(state: PreferencesState = initialStateforPreferences, action: SummaryActions): PreferencesState {

  switch (action.type) {
    case SummaryActionTypes.GetPreferences: {
      return {...state, Loaded: false, Loading: true};
    }
    case SummaryActionTypes.GetPreferencesFail: {
      return {...state, Loaded: true, Loading: false};
    }
    case SummaryActionTypes.UpsertPreferences: {
      return {...state, Loaded: true, Loading: false , entities: action.payload.preferences};
    }
    default:
    return state;
  }
}

export function summaryDetailReducer(state: SummaryDetailState = initialStateforSummaryDetailState, action: SummaryActions): SummaryDetailState {
  switch (action.type) {
    case SummaryActionTypes.GetSummaryDetail:
      return {...state, Loaded: false, Loading: true};
    case SummaryActionTypes.GetSummaryDetailSuccess:
      return {...state, Loaded: true, Loading: false , entities: action.payload};
    case SummaryActionTypes.GetSummaryDetailFail:
      return {...state, Loaded: true, Loading: false};
    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const getPreferencesState = (state: PreferencesState) => state;
export const getSummaryDetailState = (state: SummaryDetailState) => state;
